import { useEffect } from 'react'

import { useToastStore } from './useToastStore'

import styles from './styles.module.scss'

const AUTOHIDE_MS = 4000

export function ToastContainer () {
  const toasts = useToastStore((state) => state.toasts)
  const removeToast = useToastStore((state) => state.removeToast)

  useEffect(() => {
    const timers = toasts.map((toast) =>
      setTimeout(() => removeToast(toast.id), AUTOHIDE_MS)
    )
    return () => {
      timers.forEach((timer) => clearTimeout(timer))
    }
  }, [ toasts, removeToast ])

  if (!toasts.length) return null

  return (
    <div className={styles.container}>
      {toasts.map((toast) => (
        <div key={toast.id} className={`${styles.toast} ${styles[toast.variant]}`}>
          <span>{toast.message}</span>
          <button type="button" onClick={() => removeToast(toast.id)} aria-label="close">
            ×
          </button>
        </div>
      ))}
    </div>
  )
}
